import { setFilterPrefixes } from 'utils/api'

export const CITIZEN_FIELDS_INITIAL_VALUES = setFilterPrefixes('unified_person', {
  search: '',
  id: '',
  name: '',
  social_name: '',
  mother_name: '',
  father_name: '',
  cnpj_number: '',
  cpf_number: '',
  cns_number: '',
  ctps_pis_number: '',
  rg_number: '',
  sex: '',
  race: '',
  ethnicity: '',
  main_address_neighbourhood: '',
  health_place_name: '',
  school_place_name: '',
  social_place_name: '',
  gov_place_name: '',
  jobsite_name: '',
  unified_person_id: '',
  unified_person_name: '',
  unified_person_social_name: '',
  unified_person_mother_name: '',
  unified_person_father_name: '',
  unified_person_cpf_number: '',
  unified_person_cns_number: '',
  unified_person_ctps_pis_number: '',
  unified_person_rg_number: '',
  unified_person_sex: '',
  unified_person_race: '',
  unified_person_main_address_neighbourhood: '',
  unified_person_health_place_name: '',
  unified_person_school_place_name: '',
  unified_person_social_place_name: '',
  unified_person_gov_place_name: '',
})
